(function () {
  "use strict";

  var e = {
    175: function _(e, t, n) {
      var r = this && this.__assign || function () {
        return r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) {
            for (var o in t = arguments[n]) {
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }
          }

          return e;
        }, r.apply(this, arguments);
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.YacoinNetworks = void 0;
      var o = n(555),
          s = {
        yacoin: r(r({
          name: "yacoin"
        }, o.networks.yacoin), {
          coinType: "0",
          isTestnet: !1
        }),
        yacoin_testnet: r(r({
          name: "yacoin_testnet"
        }, o.networks.testnet), {
          coinType: "0",
          isTestnet: !0
        }),
        yacoin_regtest: r(r({
          name: "yacoin_regtest"
        }, o.networks.regtest), {
          coinType: "1",
          isTestnet: !0
        })
      };
      t.YacoinNetworks = s;
    },
    555: function _(e) {
      e.exports = require("@yaswap/yacoinjs-lib");
    }
  },
      t = {},
      n = function n(r) {
    var o = t[r];
    if (void 0 !== o) return o.exports;
    var s = t[r] = {
      exports: {}
    };
    return e[r].call(s.exports, s, s.exports, n), s.exports;
  }(175);

  module.exports = n;
})();